import styled from 'styled-components';
import Theme from '../theme/Theme';

const ErrorMsg = styled.div`
  color: ${Theme.red};
  font-size: ${Theme.extraNormal};
  padding: 0;
  margin: 0 0 0 0;
  transform: translate(0, 6px);

  a {
    text-transform: lowercase;
    text-decoration: underline;
    display: block;
    color: ${Theme.red};
    font-size: ${Theme.extraSmall};
  }

  &.adjust {
    margin-top: -10px;
    padding-bottom: 25px;
  }
`;
export default ErrorMsg;
